export default function Technology() {
  const features = [
    {
      icon: 'ri-vr-box-line',
      title: 'Multi-sensory UE5 Environments',
      description: 'Immersive worlds built with Unreal Engine 5',
      color: 'cyan'
    },
    {
      icon: 'ri-brain-line',
      title: 'AI-Guided Missions',
      description: 'Real-time feedback and adaptive challenges',
      color: 'purple'
    },
    {
      icon: 'ri-scan-2-line',
      title: 'AR Experiences',
      description: 'Digital overlays enhance physical space',
      color: 'green'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Digital Badges; NFTs',
      description: 'Achievement tracking and community unlocks',
      color: 'orange'
    },
    {
      icon: 'ri-live-line',
      title: 'Live Streaming',
      description: 'Real-time participation and engagement',
      color: 'pink'
    }
  ];

  const colorMap: Record<string, string> = {
    cyan: 'from-cyan-400 to-cyan-600',
    purple: 'from-purple-400 to-purple-600',
    green: 'from-green-400 to-green-600',
    orange: 'from-orange-400 to-orange-600',
    pink: 'from-pink-400 to-pink-600'
  };

  return (
    <section id="technology" className="py-32 bg-black relative overflow-hidden">
      {/* Animated Circuit Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2300D9FF' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        backgroundSize: '60px 60px'
      }}></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <h2 className="text-5xl md:text-6xl font-bold text-white text-center mb-6">
          Technology That Elevates Human Connection
        </h2>
        <div className="w-32 h-1 bg-cyan-400 mx-auto mb-20"></div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-0">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group relative flex flex-col items-center text-center p-10 border-r border-cyan-400/20 last:border-r-0 hover:bg-white/5 transition-all duration-300"
            >
              <div className={`w-24 h-24 rounded-lg bg-gradient-to-br ${colorMap[feature.color]} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} text-4xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-white mb-4 leading-tight">
                {feature.title}
              </h3>
              
              <p className="text-gray-400 text-base max-w-[200px]">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-2xl text-cyan-400 font-light italic max-w-4xl mx-auto">
            Technology is not the focus — it amplifies presence, creativity and shared experience.
          </p>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a 
            href="#contact" 
            className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-orange-500 to-orange-600 rounded-full text-white font-bold text-lg hover:shadow-2xl hover:shadow-orange-500/50 transition-all hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            Discover The Technology
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
